export default __webpack_public_path__ + "static/2466-1983cb8be1d1de6f396516eac1bdc7c6.gif";